import type { UserRole } from '@/types';

/**
 * Roles the `/notifications` page admits. The header bell links there, so it is
 * drawn only for these roles (#652: a customer, POSP or country admin clicking
 * it landed on Access Denied). `notificationRoles.test.ts` pins this list to the
 * literal `allowedRoles` on the route in `App.tsx`, so the two cannot drift.
 */
export const NOTIFICATION_ROLES: UserRole[] = [
  'super_admin',
  'broker_admin',
  'broker_employee',
  'insurer_admin',
  'insurer_employee',
];
